import React, { useEffect, useState } from 'react';
import API from '../api';
import { differenceInCalendarDays, parseISO } from 'date-fns';

export default function Quote() {
  const [rows, setRows]           = useState([]);
  const [dropdowns, setDropdowns] = useState({});
  const [filterStatus, setFilterStatus] = useState('');

  useEffect(() => {
    (async ()=>{
      const [rRes, dRes] = await Promise.all([
        API.get('/api/quote'),
        API.get('/api/dropdowns'),
      ]);
      setRows(rRes.data||[]);
      setDropdowns(dRes.data||{});
    })();
  }, []);

  if (!rows.length) return <div style={{padding:20}}>Loading quotes…</div>;

  const header   = rows[0];
  const dataRows = rows.slice(1).filter(r=>r.some(c=>c!==''));
  const now      = new Date();

  const statuses = dropdowns['Quote Status'] || [];

  const filtered = dataRows.filter(r =>
    (!filterStatus || r[header.indexOf('Quote Status')] === filterStatus)
  );

  const returnToDesign = async idx => {
    await API.post(`/api/quote/${idx}/return-to-design`);
    const r2 = await API.get('/api/quote');
    setRows(r2.data||[]);
  };

  return (
    <div style={{padding:20}}>
      <h2>Quote</h2>
      <div className="filter-bar">
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)}>
          <option value="">All Status</option>
          {statuses.map(s=> <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="table-container" style={{marginTop:20}}>
        <table>
          <thead>
            <tr>
              {header.map((h,i)=><th key={i}>{h}</th>)}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((row,ri)=>{
              const dueIdx = header.findIndex(h=>/due date/i.test(h));
              let cls='';
              if(dueIdx>=0 && row[dueIdx]){
                const diff = differenceInCalendarDays(parseISO(row[dueIdx]), now);
                cls = diff<0?'overdue':diff<=3?'due-soon':'';}
              return (
                <tr key={ri} className={cls}>
                  {row.map((c,ci)=><td key={ci}>{c}</td>)}
                  <td>
                    {row[header.indexOf('Quote Status')] === 'Confirmed' && (
                      <button className="btn btn-primary" onClick={()=>returnToDesign(ri)}>
                        Return to Design
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
